import { render, staticRenderFns } from "./AttachFiles.vue?vue&type=template&id=c069ee32&scoped=true"
import script from "./AttachFiles.vue?vue&type=script&lang=js"
export * from "./AttachFiles.vue?vue&type=script&lang=js"
import style0 from "./AttachFiles.vue?vue&type=style&index=0&id=c069ee32&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c069ee32",
  null
  
)

export default component.exports